// extracted by mini-css-extract-plugin
export default {"lobby":"Lobby_lobby__Ql8pB","appLogo":"Lobby_appLogo__0yHLD","form":"Lobby_form__qze65","button":"Lobby_button__VgoGt","list":"Lobby_list__eRhdk"};